module.exports = __webpack_public_path__ + "static/media/construction-cone.cd754f5b.svg";